import type { SVGProps } from "react";
const SvgSend = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#A0A0A0"
      d="M2 13.333V2.667L14.667 8zm1.333-2L11.233 8l-7.9-3.333V7l4 1-4 1zm0 0V4.667v6.666"
    />
  </svg>
);
export default SvgSend;
